/**
 * @module components\mixins\slotName
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SlotName extends Vue {
  protected getCellSlotName(header: ITableHeader) {
    return "table-cell-" + header.value;
  }

  protected getModelSlotName(prop: IProp) {
    return "model-prop-" + prop.value;
  }

  protected getViewSlotName(prop: IProp) {
    return "view-prop-" + prop.value;
  }
}
